import { ReactNode } from "react";

export type MenuItem = {
  label: string;
  value: string;
};

export type MenuItems = Array<MenuItem>;

export type MenuItemExtended = {
  label: string | ReactNode;
  value: string;
};
